export default __webpack_public_path__ + "static/media/commonmistakes@2x.ac324811.jpg";